module.exports = __webpack_public_path__ + "static/media/dinner_icon.23c35806.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/configurator/dinner_icon.png
// module id = 1515
// module chunks = 0